import { render, staticRenderFns } from "./DraftsMail.vue?vue&type=template&id=f1184c4e&scoped=true&"
import script from "./DraftsMail.vue?vue&type=script&lang=js&"
export * from "./DraftsMail.vue?vue&type=script&lang=js&"
import style0 from "./DraftsMail.vue?vue&type=style&index=0&id=f1184c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1184c4e",
  null
  
)

export default component.exports